import { UpdateMeetAndGreetProperties } from '../../../redux/API/ClientAPIHelpers/soapNoteProperties';

export enum ACTIONS {
	setState = 'setState',
	setDate = 'setDate',
	setEndTime = 'setEndTime',
	setStartTime = 'setStartTime',
	setLocationId = 'setLocationId',
	setBarriers = 'setBarriers',
	setBarriersOther = 'setBarriersOther',
	setGoalsAddressed = 'setGoalsAddressed',
	setParticipants = 'setParticipants',
	setMeetAndGreetParticipantOther = 'setMeetAndGreetParticipantOther',
	setSessionSummary = 'setSessionSummary',
	setSignature = 'setSignature',
}

export interface ActionProperties {
	payload: any;
	type: keyof typeof ACTIONS;
}

export const initialMeetAndGreetState: UpdateMeetAndGreetProperties = {
	date: '',
	endTime: '',
	locationId: null,
	sessionSummary: '',
	sessionId: '',
	signature: '',
	startTime: '',
	submit: false,
	participantResponses: [],
	forcedOperation: false,
	clientTelehealthLocationId: '',
	userTelehealthLocationId: '',
	clientId: '',
	reportId: '',
	barrierToTreatmentResponses: [],
	barrierToTreatmentOther: '',
	meetAndGreetParticipantOther: '',
};

export const meetAndGreetReducer = (
	state: UpdateMeetAndGreetProperties,
	action: ActionProperties,
): UpdateMeetAndGreetProperties => {
	const { type, payload } = action;

	switch (type) {
		case ACTIONS.setState:
			return {
				...state,
				...payload,
			};
		case ACTIONS.setParticipants:
			return {
				...state,
				participantResponses: payload,
			};
		case ACTIONS.setMeetAndGreetParticipantOther:
			return {
				...state,
				meetAndGreetParticipantOther: payload,
			};
		case ACTIONS.setSessionSummary:
			return {
				...state,
				sessionSummary: payload,
			};
		case ACTIONS.setLocationId:
			return {
				...state,
				locationId: payload,
			};
		case ACTIONS.setSignature:
			return {
				...state,
				signature: payload,
			};
		case ACTIONS.setBarriersOther:
			return {
				...state,
				barrierToTreatmentOther: payload,
			};
		case ACTIONS.setBarriers:
			return {
				...state,
				barrierToTreatmentResponses: payload,
			};
		default:
			return state;
	}
};

export enum ERRORS {
	BarriersResponses = 'BarriersResponses',
	BarriersOther = 'BarriersOther',
	LocationId = 'LocationId',
	Notes = 'Notes',
	Reinforcement = 'Reinforcement',
	SessionSummary = 'SessionSummary',
	Signature = 'Signature',
	ParticipantResponses = 'ParticipantResponses',
	ParticipantOther = 'ParticipantOther',
	GoalsAddressed = 'GoalsAddressed',
}

interface MeetAndGreetErrorProperties {
	BarriersOther: boolean;
	BarriersResponses: boolean;
	GoalsAddressed: boolean;
	LocationId: boolean;
	MeetAndGreetParticipantOther: boolean;
	ParticipantResponses: boolean;
	SessionSummary: boolean;
	Signature: boolean;
}

export interface ErrorActionProperties {
	payload: any;
	type: keyof typeof ERRORS;
}

export const initialMeetAndGreetErrorState: MeetAndGreetErrorProperties = {
	LocationId: false,
	BarriersOther: false,
	BarriersResponses: false,
	SessionSummary: false,
	Signature: false,
	ParticipantResponses: false,
	MeetAndGreetParticipantOther: false,
	GoalsAddressed: false,
};

export const MeetAndGreetErrorReducer = (state: MeetAndGreetErrorProperties, action: ErrorActionProperties) => {
	const { payload, type } = action;

	switch (type) {
		case ERRORS[type]:
			return {
				...state,
				[type]: payload,
			};
		default:
			return state;
	}
};
